export const CARGO_SCREENING_CONSENT = "cargo_screening_consent";
export const LICENSE_REQUIRED = "license_required";



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/constants.js